export default [{
    path: '/mine/phoneNumberSetting',
    name: 'phoneNumberSetting',
    meta: {
      index: 14
    },
    component: () => import('@/views/mine/phoneNumberSetting.vue')
  }]
  